import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/core/components/ui/card";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis } from "recharts";
import { ChartContainer, ChartTooltip } from "@/core/components/ui/chart";
import { configs } from "../consts/configs";
import { useTranslation } from "react-i18next";
import { ReportViewerCreditConsumptionProps } from "../types";

export function ReportViewerCreditConsumption({
  data,
  totals,
}: ReportViewerCreditConsumptionProps) {
  const [translate] = useTranslation(["insights"]);
  return (
    <Card className="border-secondary">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <span className="text-blue-600">💳</span>
          {translate("report-viewer-credit-consumption-title")}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-64 mb-6">
          <ResponsiveContainer>
            <ChartContainer config={configs} className="min-h-[200px] w-full">
              <LineChart data={data}>
                <XAxis dataKey="month" />
                <YAxis />
                <ChartTooltip />
                <Line
                  type="monotone"
                  dataKey="value"
                  stroke="#16a34a"
                  strokeWidth={2}
                />
              </LineChart>
            </ChartContainer>
          </ResponsiveContainer>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <Kpi
            value={totals.total_utilizations.toFixed(2)}
            label={translate("report-viewer-credit-consumption-total-credits")}
            className="text-blue-600 bg-blue-50"
          />
          <Kpi
            value={totals.average_by_group.toFixed(2)}
            label={translate(
              "report-viewer-credit-consumption-average-by-group",
            )}
            className="text-green-600 bg-green-50"
          />
          <Kpi
            value={String(totals.highest_group_credits)}
            label={translate(
              "report-viewer-credit-consumption-highest-consumption",
            )}
            className="text-neutral-950 bg-secondary"
          />
        </div>
      </CardContent>
    </Card>
  );
}

function Kpi({
  value,
  label,
  className,
}: {
  value: string;
  label: string;
  className?: string;
}) {
  return (
    <div className={`text-center p-4 rounded-lg ${className}`}>
      <p className="text-2xl font-bold">{value}</p>
      <p className="text-sm text-gray-600">{label}</p>
    </div>
  );
}
